import { createTrendsTypes } from '../../common/trends/types';

export const NAMESPACE = 'analytics-trends-rdc';
export default createTrendsTypes(NAMESPACE);
